import { authenticatedRequest, apiRequest } from "../lib/api";
import type { Form, FormInput, FormUpdate, ApiResponse } from "../lib/types";

export async function getForms(token: string): Promise<Form[]> {
    return authenticatedRequest<ApiResponse<Form[]>>("/api/forms", token).then(
        (res) => res.data
    );
}

export async function getForm(token: string, id: string): Promise<Form> {
    return authenticatedRequest<ApiResponse<Form>>(
        `/api/forms/${id}`,
        token
    ).then((res) => res.data);
}

export async function createForm(
    token: string,
    input: FormInput,
    folderId?: string
): Promise<Form> {
    const query = folderId ? `?folderId=${folderId}` : "";
    return authenticatedRequest<ApiResponse<Form>>(
        `/api/forms${query}`,
        token,
        {
            method: "POST",
            body: JSON.stringify(input),
        }
    ).then((res) => res.data);
}

export async function updateForm(
    token: string,
    id: string,
    input: FormUpdate
): Promise<Form> {
    return authenticatedRequest<ApiResponse<Form>>(
        `/api/forms/${id}`,
        token,
        {
            method: "PATCH",
            body: JSON.stringify(input),
        }
    ).then((res) => res.data);
}

export async function deleteForm(token: string, id: string): Promise<void> {
    return authenticatedRequest<void>(`/api/forms/${id}`, token, {
        method: "DELETE",
    });
}

export async function submitForm(
    token: string,
    id: string,
    data: Record<string, any>
): Promise<{ success: boolean }> {
    return authenticatedRequest<ApiResponse<{ success: boolean }>>(
        `/api/forms/${id}/submit`,
        token,
        {
            method: "POST",
            body: JSON.stringify(data),
        }
    ).then((res) => res.data);
}

export async function getPublicForm(id: string): Promise<Form> {
    return apiRequest<ApiResponse<Form>>(`/api/public/forms/${id}`).then(
        (res) => res.data
    );
}

export async function submitPublicForm(
    id: string,
    data: Record<string, any>
): Promise<{ success: boolean }> {
    return apiRequest<ApiResponse<{ success: boolean }>>(
        `/api/public/forms/${id}/submit`,
        {
            method: "POST",
            body: JSON.stringify(data),
        }
    ).then((res) => res.data);
}
